import { HrCommonAuthority } from './hr-common-authority';
import { combineAuth } from './hr-authority';

export class PersonnelAuthority extends HrCommonAuthority {

    public static readonly PERSONNEL_BASE = "personnel";

    constructor(authority: string) {
        super(combineAuth(PersonnelAuthority.PERSONNEL_BASE, authority));
    }

}
